import { Inject, Injectable } from "@angular/core";
import { MODULE_VERSIONS } from "./versions";
import { Subject } from "rxjs/Subject";
export class VersionService {
    constructor(moduleVersions) {
        this.moduleVersions = moduleVersions;
        this.HEADER_NAME = 'Accept-Version';
        this._requiredVersions$ = new Subject();
    }
    get requiredVersions$() {
        return this._requiredVersions$;
    }
    setVersionHeader(headers) {
        let versionMap = {};
        this.moduleVersions.forEach(x => versionMap[x.module] = x.version);
        headers.delete(this.HEADER_NAME);
        headers.append(this.HEADER_NAME, JSON.stringify(versionMap));
    }
    requireVersions(message) {
        this._requiredVersions$.next(message);
    }
}
VersionService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
VersionService.ctorParameters = () => [
    { type: Array, decorators: [{ type: Inject, args: [MODULE_VERSIONS,] },] },
];
//# sourceMappingURL=version.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/versioning/version.service.js
// module id = 145
// module chunks = 1